// extracted by mini-css-extract-plugin
module.exports = {"Content":"Carousel_Content__1_EUp","ContentNotReady":"Carousel_ContentNotReady__33e28","resourceList":"Carousel_resourceList__Fx2kA"};